<h2 mat-dialog-title data-testid="file-list-modal-title">{{ title }}</h2>
<mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let file of files" class="file-item">
      <div mat-line>{{ file.nome }}</div>
      <button mat-icon-button color="primary" (click)="download(file)" aria-label="Fazer download do arquivo">
        <mat-icon>download</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
  <p *ngIf="files.length === 0" class="text-center text-muted">Nenhum arquivo disponível</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" class="border-0" mat-dialog-close data-testid="file-list-modal-close">
    Fechar
  </button>
</mat-dialog-actions>
